import { MdOutlineClose } from 'react-icons/md';
import { TmdxChip } from '@ds';
import { getUnosId } from '@/utils/helpers';
import { Case } from '@/api/apis/case';

type SelectedCaseChipProps = {
  data: Case;
  isDisable: boolean;
  isCloseable: boolean;
  onRemove: (caseItem: Case) => void;
};

export const SelectedCaseChip = ({ data, isDisable, isCloseable, onRemove }: SelectedCaseChipProps) => {
  return (
    <TmdxChip
      size="sm"
      color="secondary"
      isDisabled={isDisable}
      endContent={isCloseable ? <MdOutlineClose size={16} /> : null}
      onClose={isCloseable ? () => onRemove(data) : undefined}
    >
      {getUnosId(
        data.donorId,
        data.organType,
        data.reAllocationSequenceNumber,
        data.opoRequest,
        data.isExpeditedCase,
        data.laterality,
        data.duplicateCaseNumber,
      )}
    </TmdxChip>
  );
};
